import { CSSProperties, ReactNode } from 'react'

import Paper from '../../ui/Paper'
import { cn } from '../../ui/cn'

const HeadingContainer = ({
  children,
  minHeight,
  style,
  className,
}: {
  minHeight?: string
  children?: ReactNode
  style?: CSSProperties
  className?: string
}) => {
  return (
    <Paper
      square
      className={cn(
        'flex shrink-0 flex-row flex-wrap items-center justify-between gap-2 px-6',
        className,
      )}
      style={{
        minHeight: minHeight || '64px',
        ...(style || {}),
      }}
    >
      {children}
    </Paper>
  )
}

export default HeadingContainer
